import { Link, PageSeo, ProgressBar, TagsPanel } from '@/components';
import config from '@/config';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const Games = () => {
	const { t } = useTranslation('common');
	const { games } = config;

	return (
		<>
			<PageSeo
				title={`Games - ${config.author}`}
				description={`Breadth First Search (BFS) algorithm - built using the React`}
				url={`${config.siteUrl}/games`}
			/>

			<div className='divide-y'>
				<div className='pt-6 pb-8 space-y-2 md:space-y-5'>
					<h1 className='text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-200 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14'>
						{t('games')}
					</h1>
				</div>
				{games.map(({ name, url, image, description, tools, languages }) => (
					<section key={url} className='text-gray-600 dark:text-gray-400 body-font overflow-hidden'>
						<div className='container px-5 py-14 mx-auto'>
							<div className='lg:w-full mx-auto flex flex-wrap'>
								<img
									alt='ecommerce'
									className='lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded'
									src={image}
								/>
								<div className='lg:w-1/2 w-full lg:pl-10 lg:pt-6 mt-6 lg:mt-0'>
									<h1 className='text-green-500 text-3xl title-font font-medium mb-4'>
										<Link href={`/games/${url}`}>{name}</Link>
									</h1>
									<p className='leading-relaxed'>{description}</p>
									<ProgressBar languages={languages} />
									<TagsPanel tags={tools} />
								</div>
							</div>
						</div>
					</section>
				))}
			</div>
		</>
	);
};

export const getStaticProps = async ({ locale }) => {
	return {
		props: {
			...(await serverSideTranslations(locale, ['common'])),
		},
		revalidate: 1,
	};
};

export default Games;
